import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import GaiaPageComponent from "../components/GaiaPageComponent";
import GaiaPageLayoutColumn from "../components/GaiaPageLayoutColumn";

type Props = {
    error?: Error;
};

export default function ErrorScreen({ error }: Props) {
    const { t } = useTranslation("app");
    return (
        <GaiaPageLayoutColumn>
            <GaiaPageComponent title={t("errorScreen.title")}>
                {error && <Typography>{error.message}</Typography>}
                {error && import.meta.env.MODE == "development" && (
                    <Typography sx={{ whiteSpace: "pre-line" }}>{error.stack}</Typography>
                )}
            </GaiaPageComponent>
        </GaiaPageLayoutColumn>
    );
}
